export const gbp = (n, opts = {}) => {
  const num = Number(n || 0);
  const isInt = Number.isInteger(num);
  return (
    "£" +
    num.toLocaleString("en-GB", {
      minimumFractionDigits: opts.forceDecimals ? 2 : isInt ? 0 : 2,
      maximumFractionDigits: 2,
    })
  );
};

export const compactGbp = (n) => {
  const num = Number(n || 0);
  if (num >= 1000) return "£" + (num / 1000).toLocaleString("en-GB", { maximumFractionDigits: 1 }) + "k";
  return gbp(num);
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const timeParts = (target) => {
  const diff = Math.max(0, new Date(target).getTime() - Date.now());
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s, done: diff <= 0 };
};
